export class Template {
    idTemplate: number;
    idCabecalho: number;
    idProjeto: number;
    idDataset: number;
    html: string;
    script: string;
    nome: string;
    nomeArquivo: string;
    nomeCabecalho: string;
    nomeProjeto: string;
    nomeDataset: string;
}
